import { render, staticRenderFns } from "./createRole.vue?vue&type=template&id=2ce1a0ce&"
import script from "./createRole.vue?vue&type=script&lang=js&"
export * from "./createRole.vue?vue&type=script&lang=js&"
import style0 from "./createRole.vue?vue&type=style&index=0&id=2ce1a0ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports